export const linkFormatting = {
  methods: {
    linkFormatting(link) {
      if (!link) return ''
      return (link.slice(0, 7) != 'http://' && link.slice(0, 8) != 'https://') ? 'http://' + link : link
    },
  },
}